{
  "main": {
    "Dashboards": "ダッシュボード",
    "Properties": "プロパティ",
    "Asset Management": "資産運用管理",
    "Controls": "コントロール",
    "Property Services": "プロパティサービス",
    "Alarms": "アラーム",
    "Reports": "報告",
    "Settings": "設定",
    "Energy Dashboard": "エネルギーダッシュボード"
  },
  "properties": {
    "You have {count} unread alerts_one": "{{count}} Unread Alertがあります",
    "You have {count} unread alerts_other": "{{count}} Unreadアラートがあります",
    "All installations are running smoothly.": "すべてのインストールはスムーズに実行されています。",
    "Choose an address first": "最初にアドレスを選択してください",
    "Properties": "プロパティ",
    "New Property": "新しいプロパティ",
    "Edit Property": "プロパティを編集します",
    "Delete Property": "プロパティを削除します",
    "Remove": "取り除く",
    "Are you sure you want to remove property": "財産を削除したいですか？",
    "You cannot delete the property": "プロパティを削除できません",
    "because the following items are blocking deletion.": "次の項目が削除をブロックしているためです。",
    "To delete the property, you must first remove the following items.": "プロパティを削除するには、最初に次の項目を削除する必要があります。",
    "Devices":"デバイス",
    "Dashboards": "ダッシュボード",
    "Widgets": "ウィジェット",
    "Attention": "注意",
    "Current Month's Consumption": "今月の消費",
    "Actual Costs": "現在の毎月の費用",
    "Name": "名前",
    "Address": "住所",
    "Timezone": "タイムゾーン",
    "Currency": "通貨",
    "Contacts": "連絡先",
    "Select Users": "ユーザーを選択します",
    "Surname": "姓",
    "Email": "メール",
    "Role": "役割",
    "Phone": "電話",
    "Choose an Image": "画像を選択してください",
    "Heated Floor Area": "加熱された床面積",
    "Value must be positive": "値は正の数でなければなりません",
    "Heating System Type": "暖房システムの種類",
    "Electricity": "電気",
    "Natural Gas": "天然ガス",
    "District Heating": "地域暖房",
    "Oil": "石油",
    "Heat Pump Air": "空気熱ポンプ",
    "Heat Pump Earth": "地熱ポンプ",
    "Category": "カテゴリ",
    "Healthcare": "ヘルスケア",
    "Industrial": "産業",
    "Hotel": "ホテル",
    "Office": "オフィス",
    "Office/Residential": "オフィス/住宅",
    "Other": "その他",
    "Residential": "住宅",
    "Retail": "小売",
    "Retail/office": "小売/オフィス",
    "Warehouse": "倉庫",
    "Heating Energy Consumption": "暖房エネルギー消費",
    "Electrical Energy Consumption": "電気エネルギー消費",
    "Construction Year": "建設年",
    "Please enter a valid year (e.g. 2020)": "有効な年を入力してください（例：2020）",
    "Today's Consumption": "今日の消費",
    "Sort: {label}": "ソート：{{label}}",
    "Priority": "優先度",
    "Alphabetic (A-Z)": "アルファベット（A-Z）",
    "Alphabetic (Z-A)": "アルファベット（Z-A）",
    "cancel": "キャンセル",
    "Create": "作成する",
    "Save": "保存",
    "Update": "アップデート",
    "This field is required": "この項目は必須です",
    "{name} was created successfully": "{{name}}は正常に作成されました",
    "{name} was updated successfully": "{{name}}は正常に更新されました",
    "Property deleted successfully": "プロパティは正常に削除されました",
    "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
    "An error occurred while updating {name}": "{{name}}の更新中にエラーが発生しました",
    "An error occurred while deleting property": "プロパティの削除中にエラーが発生しました",
    "Back": "戻る",
    "Next": "次",
    "Add Key Contact": "キー連絡先を追加します",
    "Add Contacts": "連絡先を追加します",
    "Phone is not valid (e.g., +39...)": "電話は無効です（例：+39 ...）",
    "Email is not valid (e.g., user@example.com)": "電子メールは無効です（例：user@example.com）",
    "Address is not valid": "アドレスは無効です",
    "Please fill in all required fields before moving forward": "前進する前に、必要なすべてのフィールドに記入してください",
    "Some fields are not valid": "一部のフィールドは無効です",
    "Add Gateway": "ゲートウェイを追加します"
  },
  "property_details": {
    "Properties": "プロパティ",
    "Property Details": "プロパティの詳細",
    "You have a total of {tot} events, {totAlerts} of which requires your attention": "合計{{tot}}イベントがあります。{{{totAlerts}}}に注意が必要です",
    "You have a total of {tot} devices, {totAlerts} of which requires your attention": "合計{{tot}}デバイスがあります。{{{totAlerts}}}に注意が必要です",
    "Property not found": "プロパティが見つかりません",
    "Today's Details": "今日の詳細",
    "Current Month's Consumption": "今月の消費",
    "Today's Consumption": "今日の消費",
    "Actual costs": "現在の毎月の費用",
    "Key contacts": "キー連絡先",
    "Events": "イベント",
    "Devices": "デバイス",
    "tabs": {
      "property_events": {
        "Name": "名前",
        "State": "州",
        "Last update": "最後の更新",
        "Condition": "状態",
        "Offline": "オフライン",
        "Okay": "わかった",
        "In alarm": "アラームで"
      },
      "property_devices": {
        "Name": "名前",
        "State": "州",
        "Last update": "最後の更新",
        "Condition": "状態",
        "Offline": "オフライン",
        "Okay": "わかった",
        "In alarm": "アラームで",
        "Category": "カテゴリ",
        "Communication Protocol": "通信プロトコル",
        "CURRENT_SENSOR": "現在のセンサー",
        "ENERGY_METER": "エネルギーメーター",
        "I_O_MODULE": "I/Oモジュール",
        "INS_S_H": "ins-s/h",
        "MODBUS": "modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "メーターwmbus",
        "METER_LINKY": "メーターリンク",
        "METER_P1": "メーターP1",
        "THIRD_PARTY_RTU": "サードパーティRTU",
        "THIRD_PARTY_TCP": "サードパーティのTCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "そして[a]",
        "DC_A": "dc [a]",
        "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
        "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]",
        "Groups": "グループ",
        "Delete Gateway": "ゲートウェイを削除します",
        "N. Of alarms to be checked": "チェックするアラームのN.",
        "N. Of automations to be checked": "チェックされる自動化のN."
      }
    }
  },
  "asset_management": {
    "Asset Management": "資産運用管理",
    "Devices": "デバイス",
    "Groups": "グループ",
    "Add Device": "デバイスを追加します",
    "New Group": "新しいグループ",
    "You are managing a total of {tot} devices, of which {connected} are Â«connectedÂ», {offline} Â«offlineÂ», {noCommunication} with no communication": "{{tot}}デバイスの合計を管理しています。その{{{connected}}は、コミュニケーションなしで{{connected}}は直面»、{{offline}}、{{noCommunication}}です。",
    "You have a total of {tot} groups configured": "合計{{tot}}グループが構成されています",
    "tabs": {
      "devices": {
        "Offline": "オフライン",
        "Okay": "わかった",
        "Needs intervention": "介入が必要です",
        "Name": "名前",
        "Status": "状態",
        "Category": "カテゴリ",
        "Group": "グループ",
        "Property": "財産",
        "Device Name": "デバイス名",
        "Communication Protocol": "通信プロトコル",
        "Power": "力",
        "Temperature": "温度",
        "Asset not found": "資産が見つかりません",
        "n/a": "n/a",
        "Manufacturer": "メーカー",
        "Model": "モデル",
        "S/N": "s/n",
        "Most Recent Events": "最新のイベント",
        "State": "州",
        "Last Update": "最後の更新",
        "Condition": "状態",
        "see all events": "すべてのイベントをご覧ください",
        "Auxiliary Contact": "補助接触",
        "CURRENT_SENSOR": "現在のセンサー",
        "ENERGY_METER": "エネルギーメーター",
        "I_O_MODULE": "I/Oモジュール",
        "INS_S_H": "ins-s/h",
        "MODBUS": "modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "メーターwmbus",
        "METER_LINKY": "メーターリンク",
        "METER_P1": "メーターP1",
        "THIRD_PARTY_RTU": "サードパーティRTU",
        "THIRD_PARTY_TCP": "サードパーティのTCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "そして[a]",
        "DC_A": "dc [a]",
        "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
        "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]",
        "Meter Linky": "メーターリンク",
        "Meter P1": "メーターP1",
        "Third Party RTU": "サードパーティRTU",
        "Third Party TCP": "サードパーティのTCP",
        "asset_details": {
          "Status": "状態",
          "Last update": "最後の更新",
          "Last update by": "最後の更新",
          "Condition": "状態",
          "Offline": "オフライン",
          "Okay": "わかった",
          "Needs intervention": "介入が必要です",
          "Current status": "現在のステータス",
          "Device details": "デバイスの詳細",
          "Device control": "デバイス制御",
          "Device firmware": "デバイスファームウェア",
          "Latest Firmware Update": "最新のファームウェアアップデート",
          "Current Firmware": "現在のファームウェア",
          "Updating firmware...": "ファームウェアの更新...",
          "New FW update available": "新しいFWアップデートが利用可能です",
          "Updated to the latest firmware": "最新のファームウェアに更新されました",
          "Update firmware": "ファームウェアを更新します",
          "On": "の上",
          "Off": "オフ",
          "CLOSED": "閉じた",
          "OPEN": "開ける",
          "CURRENT_SENSOR": "現在のセンサー",
          "ENERGY_METER": "エネルギーメーター",
          "I_O_MODULE": "I/Oモジュール",
          "INS_S_H": "ins-s/h",
          "MODBUS": "modbus",
          "SCU200": "SCU200",
          "METER_W_MBUS": "メーターwmbus",
          "METER_LINKY": "メーターリンク",
          "METER_P1": "メーターP1",
          "THIRD_PARTY_RTU": "サードパーティRTU",
          "THIRD_PARTY_TCP": "サードパーティのTCP",
          "TRMS_A": "TRMS [A]",
          "AC_A": "そして[a]",
          "DC_A": "dc [a]",
          "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
          "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]",
          "Current Consumption": "今日の平均消費",
          "Highest Peak load current month": "最も高い消費現在の月",
          "Average Monthly consumption": "平均月額消費",
          "Total monthly cost": "合計月額費用",
          "Name": "名前",
          "Manufacturer": "メーカー",
          "Model": "モデル",
          "Serial Number": "シリアルナンバー",
          "Service Contract": "サービス契約",
          "Installation Date": "インストール日",
          "Location": "位置",
          "Coordinates": "座標",
          "Power": "力",
          "Charging speed": "充電速度",
          "Back to devices": "デバイスに戻ります",
          "Export history": "輸出履歴",
          "From": "から",
          "To": "に",
          "Generate report": "レポートを生成します",
          "Low": "低い",
          "High": "高い",
          "cancel": "キャンセル",
          "Apply": "適用する",
          "File generated successfully": "正常に生成されたファイル",
          "An error occurred while generating export file": "エクスポートファイルの生成中にエラーが発生しました",
          "Edit device": "デバイスの編集",
          "Save": "保存",
          "Latitude": "緯度",
          "Longitude": "経度",
          "Device details updated": "デバイスの詳細が更新されました",
          "An error occurred while updating device details": "デバイスの詳細の更新中にエラーが発生しました",
          "User": "ユーザー",
          "Groups": "グループ",
          "Automations": "自動化",
          "Alarms": "アラーム",
          "Port_1_State": "ポート1ステータス",
          "Port_2_State": "ポート2ステータス",
          "Port_3_State": "ポート3ステータス",
          "Port_4_State": "ポート4ステータス",
          "TripStatus": "旅行ステータス",
          "MCBTemperature": "MCB温度"
        }
      },
      "groups": {
        "Name": "名前",
        "Multiple properties": "複数のプロパティ",
        "Consumption": "消費",
        "Property": "財産",
        "Description": "説明",
        "cancel": "キャンセル",
        "Create": "作成する",
        "New Group": "新しいグループ",
        "Search" : "検索...",
        "Preview": "プレビュー",
        "Assets": "資産",
        "Select at least one asset": "少なくとも1つの資産を選択します",
        "{name} was created successfully": "{{name}}は正常に作成されました",
        "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
        "{name} was updated successfully": "{{name}}は正常に更新されました",
        "An error occurred while updating {name}": "{{name}}の更新中にエラーが発生しました",
        "Save": "保存",
        "Are you sure you want to remove group": "グループを削除したいですか？",
        "Group removed successfully": "グループは正常に削除されました",
        "Remove": "取り除く",
        "Edit Group": "グループの編集",
        "Remove Group": "グループを削除します"
      }
    }
  },
  "controls": {
    "Controls": "コントロール",
    "You have no automations configured yet": "まだ自動化が構成されていません",
    "You have a total of {tot} devices to be controlled": "制御する合計{{tot}}デバイスがあります",
    "You have a total of {tot} automations configured. In the last 5 days, {lastRan} have run and {failed} were not possible to be executed": "合計{{tot}}自動化が構成されています。過去5日間で、{{lastRan}}が実行され、{{failed}}が実行できませんでした",
    "Manual Control": "手動制御",
    "Automations": "自動化",
    "New Automation": "新しい自動化",
    "tabs": {
      "manual_control": {
        "Status": "",
        "Offline": "オフライン",
        "Connected": "接続",
        "Needs intervention": "介入が必要です",
        "Device Name": "デバイス名",
        "Device Category": "デバイスカテゴリ",
        "Group": "グループ",
        "Name": "名前",
        "Off/On": "オフ/オン",
        "Action": "アクション",
        "Temperature": "温度",
        "CURRENT_SENSOR": "現在のセンサー",
        "ENERGY_METER": "エネルギーメーター",
        "I_O_MODULE": "I/Oモジュール",
        "INS_S_H": "ins-s/h",
        "MODBUS": "modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "メーターwmbus",
        "METER_LINKY": "メーターリンク",
        "METER_P1": "メーターP1",
        "THIRD_PARTY_RTU": "サードパーティRTU",
        "THIRD_PARTY_TCP": "サードパーティのTCP",
        "Charging Speed": "充電速度",
        "Are you sure that you want to change the status from {fromStatus} to {toStatus} of the": "ステータスを{{fromStatus}}から{{toStatus}}に変更する必要がありますか",
        "cancel": "キャンセル",
        "Turn {toStatus}": "turn {{toStatus}}",
        "{deviceName} was turned {devicePowerStatus} successfully": "{{deviceName}}は{{devicePowerStatus}}に成功しました"
      },
      "automations": {
        "New Automation": "新しい自動化",
        "Edit Automation": "自動化を編集します",
        "cancel": "キャンセル",
        "Create": "作成する",
        "Save": "保存",
        "Next": "次",
        "Back": "戻る",
        "Apply": "適用する",
        "Trigger": "トリガー",
        "On selected period": "選択した期間",
        "Start date": "開始日",
        "End date": "終了日",
        "Automation Name": "自動化名",
        "Name": "名前",
        "Conditions": "条件",
        "Type": "タイプ",
        "Select the type of asset you would like to create an automation for": "自動化を作成したい資産の種類を選択します",
        "Properties": "プロパティ",
        "Groups": "グループ",
        "Devices": "デバイス",
        "Search": "検索",
        "Device": "デバイス",
        "Event Type": "イベントタイプ",
        "Measure": "測定",
        "Threshold": "しきい値",
        "Add another condition": "別の条件を追加します",
        "Time delay (seconds)": "時間遅延（秒）",
        "Delay": "遅れ",
        "Alarm": "アラーム",
        "Send event": "イベントを送信します",
        "Enabled": "有効になっています",
        "Device Details": "デバイスの詳細",
        "Port": "ポート",
        "Action": "アクション",
        "Please fill in all required fields before moving forward": "前進する前に、必要なすべてのフィールドに記入してください",
        "You have to exit edit mode to proceed": "続行するには、編集モードを終了する必要があります",
        "Please save or cancel changes to current condition before adding a new one": "新しい状態を追加する前に、現在の状態に変更を保存またはキャンセルしてください",
        "Please save or cancel changes to current condition before editing another one": "別の条件を編集する前に、現在の状態に変更を保存またはキャンセルしてください",
        "Please save or cancel changes to current condition before removing another one": "別の条件を削除する前に、現在の状態に変更を保存またはキャンセルしてください",
        "Are you sure you want to remove condition": "状態を削除したいのですが",
        "Please remove duplicated conditions before proceeding": "先に進む前に、重複した条件を削除してください",
        "Remove": "取り除く",
        "No": "いいえ",
        "Yes": "はい",
        "WARNING: This action will result in losing any unsaved changes.<br>Do you want to save changes before continuing": "警告：このアクションは、救われていない変更を失うことになります。<br>継続する前に変更を保存したいですか",
        "Please save or cancel changes to current condition before leaving this step": "このステップを離れる前に、現在の状態の変更を保存またはキャンセルしてください",
        "{name} was created successfully": "{{name}}は正常に作成されました",
        "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
        "{name} was updated successfully": "{{name}}は正常に更新されました",
        "An error occurred while updating {name}": "{{name}}の更新中にエラーが発生しました",
        "Configured": "構成",
        "Logs": "ログ",
        "This field is required": "この項目は必須です",
        "Invalid date": "無効な日付",
        "OPEN": "開ける",
        "CLOSE": "近い",
        "tabs": {
          "configured": {
            "Automation Name": "自動化名",
            "Show with alarm only": "アラームのみで表示します",
            "Show enabled automations only": "有効な自動化のみを表示します",
            "Yes": "はい",
            "No": "いいえ",
            "Name": "名前",
            "When": "いつ",
            "If": "もし",
            "Then": "それから",
            "Alarm": "アラーム",
            "Last update": "最後の更新",
            "Failed": "失敗した",
            "years ago": "数年前",
            "months ago": "数か月前",
            "days ago": "数日前",
            "hours ago": "数時間前",
            "minutes ago": "数分前",
            "seconds ago": "数秒前",
            "just now": "ちょうど今",
            "Enabled": "有効になっています",
            "Properties": "プロパティ",
            "Groups": "グループ",
            "Devices": "デバイス",
            "Conditions": "条件",
            "New Automation - IF": "新しい自動化 -  if",
            "Type": "タイプ",
            "Device": "デバイス",
            "Event Type": "イベントタイプ",
            "Measure": "測定",
            "Threshold": "しきい値",
            "Add another condition": "別の条件を追加します",
            "Time delay (seconds)": "時間遅延（秒）",
            "Delay": "遅れ",
            "Send event": "イベントを送信します",
            "New Automation - Then": "新しい自動化 - それでは",
            "Device Details": "デバイスの詳細",
            "Port": "ポート",
            "Action": "アクション",
            "cancel": "キャンセル",
            "Create": "作成する",
            "Back": "戻る",
            "Are you sure that you want to {action}": "{{action}}したいのですが",
            "Enable": "有効にする",
            "Disable": "無効にします",
            "Set in alarm": "アラームに設定します",
            "set in alarm": "アラームに設定します",
            "disable": "無効にします",
            "enable": "有効にする",
            "remove": "取り除く",
            "enabled": "有効になっています",
            "disabled": "無効",
            "enabled_other": "有効になっています",
            "disabled_other": "無効",
            "enabling": "有効化",
            "disabling": "無効化",
            "Remove": "取り除く",
            "all selected items": "選択したすべてのアイテム",
            "Automation {action} successfully": "自動化{{action}}に正常に",
            "An error occurred while {action} automation": "{{action}}自動化中にエラーが発生しました",
            "Selected automations are already {status}": "選択された自動化はすでに{{status}}です",
            "Selected automations are already in alarm status": "選択した自動化はすでにアラームステータスにあります",
            "Automation deleted successfully": "自動化が正常に削除されました",
            "An error occurred while deleting the automation": "自動化の削除中にエラーが発生しました",
            "Automation set successfully in alarm": "自動化はアラームで正常に設定されています",
            "An error occurred while setting automation in alarm": "アラームで自動化を設定したときにエラーが発生しました",
            "Group": "グループ",
            "Property": "財産",
            "SYSTEM": "システム",
            "CROSS_UP": "交差します",
            "CROSS_DOWN": "交差します",
            "STATUS_CHANGE": "ステータスの変更",
            "COMMUNICATION_FAILURE": "コミュニケーションの失敗",
            "COMMUNICATION_RESTORE": "コミュニケーションの復元",
            "STATUS_CHANGE_TO_CLOSED": "ステータスが閉じて変更されます",
            "STATUS_CHANGE_TO_OPEN": "ステータスが開くように変更されます",
            "AUTOMATION_SUCCESS": "自動化の成功",
            "AUTOMATION_FAILURE": "自動障害",
            "VALUE_MATCH": "値マッチ",
            "STATUS_CHANGE_TO_ON": "ステータスがオンに変更されます",
            "STATUS_CHANGE_TO_OFF": "ステータスがオフに変更されます",
            "VALUE_CHANGE": "価値の変化",
            "CURRENT_SENSOR": "現在のセンサー",
            "ENERGY_METER": "エネルギーメーター",
            "I_O_MODULE": "I/Oモジュール",
            "INS_S_H": "ins-s/h",
            "MODBUS": "modbus",
            "SCU200": "SCU200",
            "METER_W_MBUS": "メーターwmbus",
            "METER_LINKY": "メーターリンク",
            "METER_P1": "メーターP1",
            "THIRD_PARTY_RTU": "サードパーティRTU",
            "THIRD_PARTY_TCP": "サードパーティのTCP",
            "TRMS_A": "TRMS [A]",
            "AC_A": "そして[a]",
            "DC_A": "dc [a]",
            "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
            "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]"
          },
          "logs": {
            "Date": "日付",
            "cancel": "キャンセル",
            "Apply": "適用する",
            "Export": "輸出",
            "Start date": "開始日",
            "End date": "終了日",
            "Name": "名前",
            "When": "いつ",
            "If": "もし",
            "Then": "それから",
            "Automation time": "自動化時間",
            "Alarm": "アラーム",
            "Properties": "プロパティ",
            "Groups": "グループ",
            "Devices": "デバイス",
            "Status": "状態",
            "Successfully": "正常に",
            "Failure": "失敗",
            "Yes": "はい",
            "No": "いいえ",
            "File exported successfully": "ファイルは正常にエクスポートされました",
            "An error occurred while exporting file": "ファイルのエクスポート中にエラーが発生しました",
            "Group": "グループ",
            "Property": "財産",
            "Device": "デバイス",
            "CROSS_UP": "交差します",
            "CROSS_DOWN": "交差します",
            "STATUS_CHANGE": "ステータスの変更",
            "COMMUNICATION_FAILURE": "コミュニケーションの失敗",
            "COMMUNICATION_RESTORE": "コミュニケーションの復元",
            "STATUS_CHANGE_TO_CLOSED": "ステータスが閉じて変更されます",
            "STATUS_CHANGE_TO_OPEN": "ステータスが開くように変更されます",
            "AUTOMATION_SUCCESS": "自動化の成功",
            "AUTOMATION_FAILURE": "自動障害",
            "VALUE_MATCH": "値マッチ",
            "STATUS_CHANGE_TO_ON": "ステータスがオンに変更されます",
            "STATUS_CHANGE_TO_OFF": "ステータスがオフに変更されます",
            "VALUE_CHANGE": "価値の変化",
            "OPEN": "開ける",
            "CLOSE": "近い",
            "TRMS_A": "TRMS [A]",
            "AC_A": "そして[a]",
            "DC_A": "dc [a]",
            "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
            "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]"
          }
        }
      }
    }
  },
  "dashboards": {
    "You have {count} unread alerts_one": "<a href = 'alarms/list' class = 'underline text-blue-600'> {{count}}アクティブアラート</a>があります。",
    "You have {count} unread alerts_other": "<a href = 'alarms/list' class = 'underline text-blue-600'> {{count}}アクティブアラート</a>があります。",
    "All installation are running smoothly.": "すべてのインストールはスムーズに実行されています。",
    "No alarms require your attention.": "アラームは必要ありません。",
    "All installations are running smoothly.": "すべてのインストールはスムーズに実行されています。",
    "Create new dashboard": "新しいダッシュボードを作成します",
    "Stop editing": "編集を停止します",
    "Add widget": "ウィジェットを追加します",
    "Dashboard deleted successfully": "ダッシュボードが正常に削除されました",
    "An error occurred while deleting the dashboard": "ダッシュボードの削除中にエラーが発生しました",
    "Are you sure you want to delete \"{name}\"?": "\"{{name}}\"を削除したいですか？",
    "Delete dashboard": "ダッシュボードを削除します",
    "An error occurred while pinning the dashboard": "ダッシュボードを固定しているときにエラーが発生しました",
    "Export": "輸出",
    "File generated successfully": "正常に生成されたファイル",
    "An error occurred while generating export file": "エクスポートファイルの生成中にエラーが発生しました",
    "modal": {
      "Create": "作成する",
      "cancel": "キャンセル",
      "Name": "名前",
      "The name of your new dashboard, this will also serve as the dashboard title": "新しいダッシュボードの名前、これはダッシュボードのタイトルとしても機能します",
      "An error occurred while creating the dashboard": "ダッシュボードの作成中にエラーが発生しました",
      "Dashboard created successfully": "ダッシュボードが正常に作成されました",
      "Create Dashboard": "ダッシュボードを作成します",
      "Dashboard updated successfully": "ダッシュボードが正常に更新されました",
      "An error occurred while updating the dashboard": "ダッシュボードの更新中にエラーが発生しました",
      "Update Dashboard": "ダッシュボードを更新します",
      "Save": "保存"
    },
    "side_panel": {
      "New widget": "新しいウィジェット",
      "Widget type": "ウィジェットタイプ",
      "No results found": "-結果が見つかりません",
      "Search": "検索...",
      "Number": "番号",
      "Chart": "チャート",
      "Benchmark": "ベンチマーク",
      "Alarms/Events": "アラーム/イベント",
      "Solar": "太陽",
      "Filter": "フィルター",
      "Map": "地図",
      "Energy monitoring": "エネルギー監視",
      "Non-electrical parameters": "非電気パラメーター",
      "Cost management": "コスト管理",
      "Alarms monitoring": "アラーム監視",
      "Control": "コントロール",
      "Automations": "自動化",
      "Data analysis": "データ分析",
      "Asset monitoring": "資産監視",
      "Sustainability": "持続可能性",
      "Properties": "プロパティ",
      "Widget for metrics or instantaneous values.": "メトリックまたは瞬間値のウィジェット。",
      "Widget for visualizing a key parameter.": "キーパラメーターを視覚化するためのウィジェット。",
      "Widget for benchmark comparisons even with external sources.": "外部ソースとでもベンチマーク比較用のウィジェット。",
      "Widget for visualizing events and alarms.": "イベントやアラームを視覚化するためのウィジェット。",
      "Widget for visualizing solar generation.": "ソーラー生成を視覚化するためのウィジェット。",
      "Widget for enabling quick and frequent manual control actions.": "迅速で頻繁な手動制御アクションを有効にするためのウィジェット。",
      "Widget for filtering the dashboard details.": "ダッシュボードの詳細をフィルタリングするためのウィジェット。",
      "Widget for geolocation visualization.": "ジオロケーションの視覚化用のウィジェット。",
      "{type} widget": "{{type}}ウィジェット",
      "Widget selection": "ウィジェットの選択",
      "An error occurred while creating the widget": "ウィジェットの作成中にエラーが発生しました",
      "Widget created successfully": "ウィジェットは正常に作成されました",
      "Widget duplicated successfully": "ウィジェットは正常に複製されました",
      "Create": "作成する",
      "Update": "アップデート",
      "cancel": "キャンセル",
      "Metric": "メトリック",
      "currentTrms": "TRMS",
      "currentAc": "AC",
      "currentDc": "DC",
      "activePowerTotal": "アクティブパワー",
      "activeEnergyTotal": "アクティブエネルギー",
      "Metric type": "メトリックタイプ",
      "Assets": "資産",
      "Metric details": "メトリックの詳細",
      "Preview": "プレビュー",
      "An error occurred while updating the widget": "ウィジェットの更新中にエラーが発生しました",
      "Widget updated successfully": "ウィジェットは正常に更新されました",
      "Save": "保存",
      "Electrical values": "電気値",
      "Data presentation of general electrical values": "プロパティ、グループ、またはデバイスの一般的な電気値を表示します。",
      "Title": "タイトル",
      "Property / Group": "プロパティ /グループ",
      "Groups": "グループ",
      "No matches found": "一致が見つかりません",
      "Type": "タイプ",
      "Auxiliary Contact": "補助接触",
      "Meter WMbus": "メーターwmbus",
      "Meter Linky": "メーターリンク",
      "Meter P1": "メーターP1",
      "Third Party RTU": "サードパーティRTU",
      "Third Party TCP": "サードパーティのTCP",
      "Devices": "デバイス",
      "Display": "画面",
      "Chart (linear)": "チャート（線形）",
      "Chart (column)": "チャート（列）",
      "Chart (donut)": "チャート（ドーナツ）",
      "Table": "テーブル",
      "Gauge": "ゲージ",
      "Min": "分",
      "Max": "マックス",
      "Target (min)": "ターゲット（最小）",
      "Target (max)": "ターゲット（最大）",
      "Y axis": "y軸",
      "Data presentation of values from category \"Energy values\"": "プロパティ、グループ、またはデバイスのエネルギー値を表示します。",
      "Energy values": "エネルギー値",
      "Power quality values": "電力品質値",
      "Data presentation of values from category \"Power Quality Values\"": "プロパティ、グループ、またはデバイスの電力品質値を表示します。",
      "Custom values": "カスタム値",
      "Data presentation of values from other categories": "プロパティ、グループ、またはデバイスの特定のデバイスパラメーターを表示します。",
      "Cost benchmark": "コストベンチマーク",
      "Cost comparison data between properties, groups or devices": "プロパティ、グループ、またはデバイス間のコストを比較します。",
      "Device": "デバイス",
      "Group": "グループ",
      "Property": "財産",
      "Criteria": "基準",
      "Date": "日付",
      "Timeframe": "時間枠",
      "Today": "今日",
      "Yesterday": "昨日",
      "Last week": "先週",
      "Last month": "先月",
      "Last year": "去年",
      "Specific date": "特定の日付",
      "Cost details per property or group": "特定の時間枠内で、プロパティまたはグループのコスト内訳を提供します。",
      "Energy cost breakdown": "エネルギーコストの崩壊",
      "Max / Min values": "最大 / min値",
      "Data visualization of Max, Min and Avg values for established device conditions": "特定の時間枠内のプロパティ、グループ、またはデバイスの最大値、最小値、および平均値を表示します。",
      "Max / Min": "最大 /分",
      "Energy consumption": "エネルギー消費",
      "Data presentation of \"Energy values\" between different types of devices": "プロパティ、グループ、またはデバイスのエネルギー消費値を表示します。",
      "Data presentation of Water / Gas data": "ガスまたは水消費の詳細用に構成されたセットアップを表示します。",
      "Water / Gas": "水 /ガス",
      "Contracts & Tariffs": "契約および関税",
      "Data presentation of contracts & tariffs values": "既存の契約と関税の現在の構成を表示します。",
      "Contract": "契約",
      "Tariff": "関税",
      "Data presentation of number of alarms to be acknowledged": "プロパティごとに確認されるアラームの数を表示します。",
      "N. of alarms": "アラームのN.",
      "Data presentation of alarms triggered": "プロパティと時間枠ごとにトリガーされたアラームを監視します。",
      "Alarm log": "アラームログ",
      "Columns": "列",
      "Data presentation of automations that have occurred": "プロパティと時間枠ごとに実行されている自動化を監視します。",
      "Automations log": "自動化ログ",
      "Visualization of the current devices status": "デバイスの現在のステータスを視覚化します。",
      "Device status": "デバイスステータス",
      "Online events": "オンラインイベント",
      "Data presentation of online events": "特定の時間枠のデバイスステータスの変更を監視します。",
      "CO2 Emissions": "CO2排出量",
      "Measure the impact of your overall consumption": "全体的な消費の影響を追跡します。",
      "Visualization": "視覚化",
      "Average": "平均",
      "Single": "シングル",
      "Conversion factor": "変換係数",
      "Targets": "ターゲット",
      "Select at least one property": "少なくとも1つのプロパティを選択します",
      "Widget for customizable text options": "ガスまたは水消費の詳細用に構成されたセットアップを表示します。",
      "Text": "文章",
      "Geolocation Visualization": "構成されたプロパティのジオロケーション視覚化を提供します。",
      "Location": "位置",
      "Actual vs Target Values": "実際のターゲット値と目標値",
      "Comparison of real values vs targeted ones": "実際の値をターゲットの値と比較します。",
      "Metrics": "メトリック",
      "Metrics Target": "メトリックターゲット",
      "Metrics Threshold": "メトリックのしきい値",
      "Select at least one metric": "少なくとも1つのメトリックを選択します",
      "If Metric greater than Metric Target is Good": "メトリックターゲットよりも大きいメトリックは良いです",
      "If Metric lower than Metric Target is Good": "メトリックターゲットよりも低いメートルは良好です",
      "N/A": "n/a",
      "KPIs calculation based on existing parameters": "既存のパラメーターに基づいてKPIを計算します。",
      "KPIs Calculation": "KPIの計算",
      "Operation": "手術",
      "Add (+)": "追加（+）",
      "Subtract (-)": "（ - ）",
      "Multiply (*)": "乗算（*）",
      "Divide (/)": "分ける （/）",
      "Against": "に対して",
      "Constant": "絶え間ない",
      "Other metric": "その他のメトリック",
      "This field is required": "この項目は必須です",
      "Please fill all required fields": "必要なすべてのフィールドを埋めてください",
      "Are you sure you want to remove device": "デバイスを削除したいですか？",
      "You cannot delete device": "デバイスを削除できません",
      "To delete the device, you must first remove the following items.": "デバイスを削除するには、最初に次の項目を削除する必要があります。",
      "Dashboard": "ダッシュボード",
      "Widgets": "ウィジェット",
      "Dashboards": "ダッシュボード",
      "Alarms": "アラーム",
      "Contracts": "契約",
      "Attention": "注意",
      "Maximum 10 devices can be selected": "最大10個のデバイスを選択できます"
    },
    "currentTrms": "TRMS",
    "currentAc": "AC",
    "currentDc": "DC",
    "activePowerTotal": "アクティブパワー",
    "activeEnergyTotal": "アクティブエネルギー",
    "Do you want to delete this widget?": "このウィジェットを削除しますか？",
    "Warning": "警告",
    "An error occurred while deleting the widget": "ウィジェットの削除中にエラーが発生しました",
    "Widget deleted": "削除されたウィジェット",
    "On": "の上",
    "Off": "オフ",
    "Refresh rate": "リフレッシュレート",
    "Refresh rate was updated successfully": "リフレッシュレートは正常に更新されました",
    "Minutes {{minutes}}": "{{minutes}}分",
    "max_min_values": {
      "Min": "分",
      "Max": "マックス",
      "Avg": "平均"
    },
    "contracts_and_tariffs": {
      "Cost": "料金",
      "Total cost of contract divided by tariffs:": "契約の総費用は関税で割った：",
      "Name": "名前",
      "Type": "タイプ",
      "Tag": "タグ",
      "Devices": "デバイス",
      "Tariffs": "関税",
      "Total cost": "総コスト",
      "Usage": "使用法"
    },
    "alarm_log": {
      "Name": "名前",
      "State": "州",
      "Condition": "状態",
      "Time": "時間",
      "Property": "財産",
      "Groups": "グループ",
      "NAME": "名前",
      "STATE": "州",
      "CONDITION": "状態",
      "TIME": "時間",
      "PROPERTY": "財産",
      "GROUPS": "グループ"
    },
    "automations_log": {
      "Name": "名前",
      "Conditions (WHEN/IF/THEN)": "条件（いつ/if/then）",
      "Time": "時間",
      "Property": "財産",
      "Groups": "グループ"
    },
    "online_events": {
      "Name": "名前",
      "Device": "デバイス",
      "Category": "カテゴリ",
      "Status": "状態",
      "Date and Time": "日時"
    },
    "list_with_target_widget": {
      "Selected properties": "選択されたプロパティ",
      "Name": "名前",
      "Value": "価値",
      "CO2 emissions": "co <sub> 2 </sub>排出量",
      "Target": "ターゲット",
      "g CO2/kWh": "g co <sub> 2 </ sub>/ kwh"
    },
    "number_and_list_widget": {
      "Number of alarms to be acknowledged": "認められるアラームの数",
      "Properties": "プロパティ"
    },
    "DEVICE_NAME": "デバイス名",
    "NAME": "名前",
    "STATE": "州",
    "CONDITION": "状態",
    "CONDITIONS": "条件",
    "TIME": "時間",
    "PROPERTY": "財産",
    "GROUPS": "グループ",
    "DATEANDTIME": "日時"
  },
  "reports": {
    "Reports": "報告",
    "You have a total of {tot} reports available.": "合計{{tot}}レポートがあります。",
    "New Report": "新しいレポート",
    "{name} was created successfully": "{{name}} は正常にキューに追加されました",
    "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
    "Name": "名前",
    "Date": "日付",
    "Author": "著者",
    "Category": "カテゴリ",
    "Format": "形式",
    "Open": "開ける",
    "Download": "ダウンロード",
    "cancel": "キャンセル",
    "Create": "作成する",
    "Apply": "適用する",
    "Report Name": "レポート名",
    "Template": "テンプレート",
    "Interval": "間隔",
    "From": "から",
    "To": "に",
    "Start date": "開始日",
    "End date": "終了日",
    "Properties": "プロパティ",
    "Search": "検索",
    "This field is required": "この項目は必須です",
    "An error occurred while exporting file": "ファイルのエクスポート中にエラーが発生しました",
    "File exported successfully": "ファイルは正常にエクスポートされました",
    "Invalid date": "無効な日付",
    "New Report Template": "新しいレポートテンプレート",
    "Edit Report Template": "レポートテンプレートを編集します",
    "Report Template Name": "レポートテンプレート名",
    "Description": "説明",
    "Components": "コンポーネント",
    "Clone": "クローン",
    "An error occurred while saving {name}": "{{name}}の保存中にエラーが発生しました",
    "{name} saved successfully": "{{name}}保存されました",
    "Save": "保存",
    "Time range: {fromDate} - {toDate}": "時間範囲：{{fromDate}}  -  {{toDate}}",
    "Printing instructions": "印刷手順",
    "You will be prompted to print this page containing the report. Make sure you remove margins and include background graphics to properly render the document": "レポートを含むこのページを印刷するように求められます。マージンを削除し、背景グラフィックを含めてドキュメントを適切にレンダリングしてください",
    "Print": "印刷",
    "Delete Report Template": "レポートテンプレートを削除します",
    "ESG report": "ESGレポート",
    "Not all values for the properties are completed": "すべてのプロパティの値が入力されているわけではありません",
    "Attention": "注意",
    "Are you sure you want to delete {name}": "{{name}}を削除したいですか",
    "Delete": "消去"
  },
  "settings": {
    "Settings": "設定",
    "Account": "アカウント",
    "Notifications": "通知",
    "General": "一般的な",
    "Users": "ユーザー",
    "New User": "新しいユーザー",
    "tabs": {
      "account": {
        "terms & conditions": "利用規約",
        "privacy notice": "ABB S.P.A.は、特にアクセスを許可して連絡するために個人データを処理します。 <a href = 'https：//new.abb.com/privacy-notice/ external-stakeholders' target = '_ blank' class = 'underline text-abb-primary hover：text-abb-primary/80'>プライバシー通知</a>",
        "Profile Picture": "プロフィール写真",
        "License": "ライセンス",
        "Account Details": "アカウントの詳細",
        "Upload/Change Your Profile": "プロフィールをアップロード/変更します",
        "Upload Avatar": "アバターをアップロードします",
        "remove": "取り除く",
        "ID": "id",
        "Assigned to": "に割り当てられます",
        "Type": "タイプ",
        "Commissioning Activation Date": "アクティベーションの試運転日",
        "Free Trial Activation": "無料試用版アクティベーション日",
        "Current Status": "現在のステータス",
        "Expiration date": "有効期限",
        "Under free trial period": "無料試用期間の下",
        "TDB": "決定される",
        "Renew": "更新します",
        "Change License": "ライセンスを変更します",
        "Name": "名前",
        "Surname": "姓",
        "Company / Legal Entity": "会社 /法人",
        "Address": "住所",
        "Phone": "電話",
        "Country": "国",
        "City": "市",
        "Postal Code": "郵便番号",
        "Email Address": "電子メールアドレス",
        "Change Details": "詳細を変更します",
        "Change Password": "パスワードを変更する",
        "Edit": "編集",
        "cancel": "キャンセル",
        "Save": "保存",
        "Confirm": "確認する",
        "Code for {attribute}": "{{attribute}}のコード",
        "Confirmation code was sent to {deliveryMedium}": "確認コードは{{deliveryMedium}}に送信されました",
        "Transfer Data": "データを転送します",
        "Transfer License": "転送ライセンス",
        "Transfer owner license to": "所有者ライセンスを転送します",
        "Search": "検索",
        "This field is required": "この項目は必須です",
        "Old password": "以前のパスワード",
        "New password": "新しいパスワード",
        "Confirm new password": "新しいパスワードを確認します",
        "Confirm new password does not match": "新しいパスワードが一致しないことを確認してください",
        "Password updated successfully": "パスワードが正常に更新されました",
        "An error occurred while updating password": "パスワードの更新中にエラーが発生しました",
        "An error occurred while updating user": "ユーザーの更新中にエラーが発生しました",
        "An error occurred while transferring license to user {fullName}": "ライセンスをユーザー{{fullName}}に転送するときにエラーが発生しました",
        "Password must be at least 8 characters long": "パスワードは少なくとも8文字の長さでなければなりません",
        "Password must not exceed 256 characters": "パスワードは256文字を超えてはなりません",
        "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "パスワードには、大文字と小文字、数字、特別な文字が含まれている必要があります（例：！@＃$％^＆*（））",
        "License {id} transferred successfully to user {name} {surname}": "ライセンス{{id}} user {{name}} {{surname}}に正常に転送されます"
      },
      "notifications": {
        "Notifications": "通知",
        "Specify how you would like to receive notifications": "通知を受信する方法を指定します",
        "Email": "メール",
        "In-app / Push Notifications": "アプリ /プッシュ通知",
        "SMS": "SMS",
        "Critical events": "重要なイベント",
        "Information Events": "情報イベント",
        "System Events": "システムイベント",
        "General information regarding the application (e.g. new upgrades, new functionalities, etc).": "アプリケーションに関する一般情報（例：新しいアップグレード、新しい機能など）",
        "Notifications linked to alarms, automations and critical connection issues.": "アラームと重要な接続の問題にリンクされた通知。",
        "General informative messages linked to non-critical connection issues.": "非批判的な接続の問題にリンクされた一般的な有益なメッセージ。"
      },
      "general": {
        "Region": "地域",
        "Language": "言語",
        "System": "システム",
        "Country": "国",
        "Timezone": "タイムゾーン",
        "Currency": "通貨",
        "This field is required": "この項目は必須です",
        "Change Region Settings": "領域設定を変更します",
        "Edit": "編集",
        "cancel": "キャンセル",
        "Save": "保存",
        "UI Aspect": "UIの側面",
        "ABB": "abb",
        "Custom": "カスタム",
        "Theme color": "テーマの色",
        "Text color": "テキスト色",
        "Logo": "ロゴ",
        "Background color": "背景色",
        "English": "英語",
        "German": "ドイツ語",
        "Italian": "イタリア語",
        "French": "フランス語",
        "Spanish": "スペイン語",
        "Version of the app": "アプリのバージョン",
        "Version": "バージョン",
        "Latest SCU200 firmware": "最新のSCU200ファームウェア",
        "Fw": "FW",
        "Current SCU200 firmware status": "現在のSCU200ファームウェアステータス",
        "View details": "詳細を表示します",
        "SCU200 firmware update": "SCU200ファームウェアアップデート",
        "No data": "データなし",
        "Updating": "更新",
        "Update available": "利用可能な更新",
        "Updated": "更新",
        "Update firmware": "ファームウェアを更新します",
        "Please select a background color": "背景色を選択してください。",
        "Please select a theme color": "テーマの色を選択してください。",
        "Please select a text color": "テキスト色を選択してください。"
      },
      "users": {
        "Name": "名前",
        "Surname": "姓",
        "Email": "メール",
        "Select Properties": "[プロパティ]を選択します",
        "Role": "役割",
        "Properties": "プロパティ",
        "Edit User": "ユーザーを編集します",
        "Remove User": "ユーザーを削除します",
        "New User": "新しいユーザー",
        "Edit": "編集",
        "cancel": "キャンセル",
        "Create": "作成する",
        "Save": "保存",
        "Admin": "管理者",
        "Advanced / Power User": "Advanced / Powerユーザー",
        "View Only (Viewer)": "ビューのみ（視聴者）",
        "Commissioner/Integrator": "コミッショナー/インテグレーター",
        "This field is required": "この項目は必須です",
        "Email is not valid (e.g., user@example.com)": "電子メールは無効です（例：user@example.com）",
        "Remove": "取り除く",
        "Are you sure you want to remove user": "ユーザーを削除したいのですが",
        "{name} was created successfully": "{{name}}は正常に作成されました",
        "{name} was updated successfully": "{{name}}は正常に更新されました",
        "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
        "An error occurred while updating {name}": "{{name}}の更新中にエラーが発生しました",
        "User deleted successfully": "ユーザーは正常に削除されました",
        "An error occurred while deleting the user": "ユーザーの削除中にエラーが発生しました",
        "End validity date": "妥当性の終了日",
        "Category": "カテゴリ",
        "Viewer": "視聴者",
        "Editing": "編集"
      },
      "user-logs": {
        "User Logs": "ユーザーログ",
        "User": "ユーザー",
        "Date": "日付",
        "Action": "アクション",
        "Object": "物体",
        "id object": "IDオブジェクト",
          "object": {
          "DASHBOARD": "ダッシュボード",
          "PROPERTY": "プロパティ",
          "USER": "ユーザー",
          "DEVICE": "デバイス",
          "ALARM": "アラーム",
          "AUTOMATION": "オートメーション",
          "REPORT": "レポート",
          "GROUP": "グループ",
          "CONTRACT": "契約",
          "WIDGET": "ウィジェット",
          "CONTROL": "コントロール",
          "REFRESH_DASHBOARD": "ダッシュボードを更新"
          },
        "action": {
          "CREATE": "作成する",
          "UPDATE": "アップデート",
          "DELETE": "消去",
          "DUPLICATE": "複製",
          "LOGIN": "ログイン",
          "LOGOUT": "ログアウト"
        },
        "create": "作成する",
        "update": "アップデート",
        "delete": "消去"
      }
    }
  },
  "commons": {
    "No notifications to display": "表示する通知なし",
    "Are you sure?": "本気ですか？",
    "cancel": "キャンセル",
    "Confirm": "確認する",
    "My Account": "私のアカウント",
    "Logout": "ログアウト",
    "An account with the given email or phone number already exists.": "指定された電子メールまたは電話番号があるアカウントはすでに存在しています。",
    "We encountered an issue while trying to send the verification code. Please check your email or phone number and try again.": "検証コードを送信しようとしているときに問題に遭遇しました。メールまたは電話番号を確認して、もう一度お試しください。",
    "The code you entered is not valid. Please double-check the code and try again.": "入力したコードは無効です。コードを再確認して、再試行してください。",
    "An error occurred with the Cognito Identity Provider service.": "Cognito Identity Providerサービスでエラーが発生しました。",
    "Concurrent modification of the resource occurred.": "リソースの同時変更が発生しました。",
    "The provider is already linked to a user.": "プロバイダーはすでにユーザーにリンクされています。",
    "Failed to enable software token MFA.": "ソフトウェアトークンMFAを有効にすることに失敗しました。",
    "The verification code you entered has expired. Please request a new code and try again.": "入力した検証コードは期限切れになりました。新しいコードをリクエストして、再試行してください。",
    "You do not have permission to perform this action.": "このアクションを実行する許可はありません。",
    "This group already exists.": "このグループはすでに存在しています。",
    "An internal error has occurred, please try again.": "内部エラーが発生しました。もう一度やり直してください。",
    "The email role access policy is not valid.": "電子メールロールアクセスポリシーは無効です。",
    "Invalid response from the Lambda function.": "ラムダ関数からの無効な応答。",
    "The specified OAuth flow is not valid.": "指定されたOAuthフローは無効です。",
    "Invalid parameter: Email format is incorrect.": "無効なパラメーター：電子メール形式が正しくありません。",
    "Invalid parameter: Phone number format is incorrect. Please make sure to include your country code.": "無効なパラメーター：電話番号形式が正しくありません。お客様の国コードを必ず含めてください。",
    "Invalid parameter: Company must be 3-50 characters long.": "無効なパラメーター：会社は3〜50文字の長さでなければなりません。",
    "Invalid parameter: Please check your input.": "無効なパラメーター：入力を確認してください。",
    "Invalid password: Password must be 8-256 characters long.": "無効なパスワード：パスワードは8〜256文字の長さでなければなりません。",
    "Invalid password: Password must include uppercase letters.": "無効なパスワード：パスワードには大文字を含める必要があります。",
    "Invalid password: Password must include lowercase letters.": "無効なパスワード：パスワードには小文字を含める必要があります。",
    "Invalid password: Password must include a number.": "無効なパスワード：パスワードには番号を含める必要があります。",
    "Invalid password: Password must include a special character (e.g., !@#$%^&*()).": "無効なパスワード：パスワードには特別な文字（！@＃$％^＆*（））を含める必要があります。",
    "Invalid password: Password must be 8-256 characters long, include uppercase and lowercase letters, a number, and a special character.": "無効なパスワード：パスワードは8〜256文字の長さで、大文字と小文字、数字、特別な文字が含まれている必要があります。",
    "The SMS role access policy is not valid.": "SMSロールアクセスポリシーは無効です。",
    "The SMS role trust relationship is not valid.": "SMSロールトラストの関係は無効です。",
    "The user pool configuration is not valid.": "ユーザープールの構成は無効です。",
    "Attempt limit exceeded, please try after some time.": "試行制限を超えて、しばらくしてみてください。",
    "The specified MFA method is not found.": "指定されたMFAメソッドは見つかりません。",
    "Incorrect username or password.": "間違ったユーザー名またはパスワード。",
    "This password was used recently. Please choose a different password.": "このパスワードは最近使用されました。別のパスワードを選択してください。",
    "Password reset is required.": "パスワードリセットが必要です。",
    "A precondition for the request is not met.": "リクエストの前提条件は満たされていません。",
    "The requested resource was not found.": "要求されたリソースは見つかりませんでした。",
    "Risk configuration exception occurred.": "リスク構成の例外が発生しました。",
    "The specified scope does not exist.": "指定されたスコープは存在しません。",
    "The software token MFA is not found.": "ソフトウェアトークンMFAは見つかりません。",
    "Too many failed attempts, please try again later.": "失敗した試みが多すぎると、後でもう一度やり直してください。",
    "Too many requests, please try again later.": "リクエストが多すぎると、後でもう一度お試しください。",
    "The request is not authorized. This can happen due to an invalid access token.": "リクエストは許可されていません。これは、無効なアクセストークンのために発生する可能性があります。",
    "An unexpected error occurred with the Lambda function.": "Lambda関数で予期しないエラーが発生しました。",
    "The specified identity provider is not supported.": "指定されたIDプロバイダーはサポートされていません。",
    "The operation is not supported.": "操作はサポートされていません。",
    "The specified token type is not supported.": "指定されたトークンタイプはサポートされていません。",
    "The user is in an unsupported state.": "ユーザーはサポートされていない状態にあります。",
    "A user import job is in progress.": "ユーザーインポートジョブが進行中です。",
    "The provided password does not meet the requirements.": "提供されたパスワードは要件を満たしていません。",
    "User is not confirmed.": "ユーザーは確認されていません。",
    "User does not exist.": "ユーザーは存在しません。",
    "The user pool add-on is not enabled.": "ユーザープールアドオンは有効になりません。",
    "The user pool tagging operation failed.": "ユーザープールのタグ付け操作に失敗しました。",
    "An account with the given email already exists.": "指定されたメールがあるアカウントはすでに存在しています。",
    "There is already a signed in user.": "すでにユーザーに署名されています。",
    "{count} items selected_one": "{{count}}アイテムが選択されました",
    "{count} items selected_other": "{{count}}アイテムが選択されています",
    "Edit": "編集",
    "Enable": "有効にする",
    "Disable": "無効にします",
    "Delete": "消去",
    "Alarm": "アラーム",
    "Clone": "クローン",
    "Warning": "警告",
    "Unauthorized Access": "不正アクセス",
    "You do not have permission to view this page": "このページを表示する許可はありません",
    "Return to Home": "家に戻ります",
    "An error occurred": "エラーが発生しました"
  },
  "login": {
    "Donâ€™t have an account? Sign-up": "アカウントを持っていませんか？サインアップ",
    "Reset mfa": "MFAをリセットします",
    "Forgot password": "パスワードをお忘れですか",
    "Reset Password": "パスワードをリセットします",
    "Back": "戻る",
    "Username": "ユーザー名",
    "Confirmation Code": "確認コード",
    "Confirmation code was sent by {deliveryMedium} to {deliveryDestination}": "確認コードは{{deliveryMedium}}から{{deliveryDestination}}に送信されました",
    "Password has been successfully reset: you can now log in with your new password": "パスワードが正常にリセットされました：新しいパスワードでログインできるようになりました",
    "New Password": "新しいパスワード",
    "Log in": "ログイン",
    "Login": "ログイン",
    "Email address": "電子メールアドレス",
    "Password": "パスワード",
    "This field is required": "この項目は必須です",
    "Email is not valid (e.g., user@example.com)": "電子メールは無効です（例：user@example.com）",
    "Password is not valid": "パスワードは無効です",
    "Password must be at least 8 characters long": "パスワードは少なくとも8文字の長さでなければなりません",
    "Password must not exceed 256 characters": "パスワードは256文字を超えてはなりません",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "パスワードには、大文字と小文字、数字、特別な文字が含まれている必要があります（例：！@＃$％^＆*（））",
    "Confirm": "確認する",
    "Code": "コード",
    "Code is not valid": "コードは無効です",
    "Code has expired": "コードが期限切れになりました",
    "Confirmation code is not valid": "確認コードは無効です",
    "Confirmation code has expired": "確認コードが期限切れになりました",
    "Scan this QR code with your authenticator app to configure Two-Factor Authentication": "2要素認証を構成するには、AuthenticatorアプリでこのQRコードをスキャンします",
    "Please open your authenticator app and enter the verification code to continue": "Authenticatorアプリを開き、検証コードを入力して続行してください"
  },
  "signup": {
    "Account Registration": "アカウント登録",
    "A confirmation code has been sent to your email. Please enter the code below to verify your account": "確認コードがメールに送信されました。アカウントを確認するには、以下のコードを入力してください",
    "Next": "次",
    "Back": "戻る",
    "Confirm": "確認する",
    "Create Account": "アカウントを作成する",
    "Name": "名前",
    "Last name": "苗字",
    "Company / Legal Entity": "会社 /法人",
    "Country": "国",
    "City": "市",
    "Postal Code": "郵便番号",
    "Address": "住所",
    "Phone": "電話",
    "Email address": "電子メールアドレス",
    "Password": "パスワード",
    "Confirm Password": "パスワードを認証する",
    "Code": "コード",
    "This field is required": "この項目は必須です",
    "Email is not valid (e.g., user@example.com)": "電子メールは無効です（例：user@example.com）",
    "Password is not valid": "パスワードは無効です",
    "Password must be at least 8 characters long": "パスワードは少なくとも8文字の長さでなければなりません",
    "Password must not exceed 256 characters": "パスワードは256文字を超えてはなりません",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "パスワードには、大文字と小文字、数字、特別な文字が含まれている必要があります（例：！@＃$％^＆*（））",
    "Confirm Password does not match": "パスワードが一致しないことを確認してください",
    "Postal Code is not valid": "郵便番号は無効です",
    "Phone is not valid (e.g., +39...)": "電話は無効です（例：+39 ...）",
    "Accept terms & conditions": "利用規約を受け入れます",
    "Minimum 3 characters are required": "最低3文字が必要です",
    "Maximum 50 characters allowed": "最大50文字が許可されています",
    "Leading and trailing spaces are not allowed": "主要なスペースとトレーリングスペースは許可されていません",
    "Address is not valid": "アドレスは無効です",
    "Email is already in use": "このメールアドレスは既に登録されています。別のメールアドレスを使用するか、ログインを試してください。",
    "privacy notice": "ABB S.P.A.は、特にアクセスを許可して連絡するために個人データを処理します。 <a href = 'https：//new.abb.com/privacy-notice/ external-stakeholders' target = '_ blank' class = 'underline text-abb-primary hover：text-abb-primary/80'>プライバシー通知</a>"
  },
  "property_services": {
    "Property Services": "プロパティサービス",
    "Benchmarks": "ベンチマーク",
    "Energy Forecasting": "エネルギー予測",
    "Costs & Tariffs": "費用と関税",
    "You have a total of {tot} devices": "合計{{tot}}デバイスがあります",
    "{count} of which requires your _one": "{{count}}そのうちが必要です",
    "{count} of which requires your _other": "{{count}}必要があります",
    "You are managing a total of {tot} devices, of which {connected} are Â«connectedÂ», {offline} Â«offlineÂ», {noCommunication} with no communication": "{{tot}}デバイスの合計を管理しています。その{{{connected}}は、コミュニケーションなしで{{connected}}は直面»、{{offline}}、{{noCommunication}}です。",
    "attention": "注意",
    "Add new contract": "新しい契約を追加します",
    "tabs": {
      "benchmarks": {
        "Select a benchmark to get started": "開始するベンチマークを選択します",
        "Benchmark": "ベンチマーク",
        "Category": "カテゴリ",
        "Interval": "間隔",
        "Metric": "メトリック",
        "Resolution": "解決",
        "From": "から",
        "To": "に",
        "cancel": "キャンセル",
        "Apply": "適用する",
        "Export": "輸出",
        "File generated successfully": "正常に生成されたファイル",
        "An error occurred while generating export file": "エクスポートファイルの生成中にエラーが発生しました",
        "BY_PROPERTIES": "プロパティによって",
        "BY_GROUPS": "グループによって",
        "BY_DEVICES": "デバイスによって"
      },
      "energy_forecasting": {},
      "costs_tariffs": {
        "Contract Name": "契約名",
        "Name": "名前",
        "Tariff": "関税",
        "Time": "時間",
        "Devices": "デバイス",
        "Type": "タイプ",
        "Tag": "タグ",
        "to": "に",
        "Edit Contract": "契約の編集",
        "Delete Contract": "契約を削除します",
        "Are you sure you want to remove contract": "契約を削除したいですか？",
        "Remove": "取り除く",
        "Contract removed successfully": "契約は正常に削除されました",
        "VIRTUAL": "バーチャル",
        "METER_MANAGED": "メーターが管理しました",
        "side_panel": {
          "cancel": "キャンセル",
          "Save": "保存",
          "Add contract": "契約を追加します",
          "Contract configuration": "契約構成",
          "Name": "名前",
          "Contract type": "契約タイプ",
          "Tag": "タグ",
          "Devices": "デバイス",
          "Tariffs": "関税",
          "Cost": "料金",
          "Apply": "適用する",
          "From": "から",
          "To": "に",
          "Remove tariff": "関税を削除します",
          "No tariffs found": "関税は見つかりません",
          "New tariff": "新しい関税",
          "Days": "日",
          "From time": "時間から",
          "To time": "時間に",
          "Contract updated": "契約が更新されました",
          "Contract created": "作成された契約",
          "An error occurred while updating contract": "契約の更新中にエラーが発生しました",
          "An error occurred while creating contract": "契約の作成中にエラーが発生しました",
          "Some fields are not valid": "一部のフィールドは無効です",
          "VIRTUAL": "バーチャル",
          "METER_MANAGED": "メーターが管理しました",
          "End time must be after start time": "終了時刻は開始時刻の後でなければなりません",
          "End date must be after start date": "終了日は開始日の後でなければなりません"
        }
      }
    }
  },
  "alarms": {
    "Alarms": "アラーム",
    "Alarms Logs": "アラームログ",
    "New Alarm": "新しいアラーム",
    "You have a total of {tot} alarms, {totAlerts} of which requires your attention": "合計{{tot}}アラーム、{{{totAlerts}}のアラームがあります。",
    "tabs": {
      "list": {
        "New Alarm": "新しいアラーム",
        "Edit Alarm": "アラームを編集します",
        "Name": "名前",
        "Date": "日付",
        "Status": "状態",
        "Condition": "状態",
        "Enabled": "有効になっています",
        "Properties": "プロパティ",
        "Groups": "グループ",
        "Properties / Groups": "プロパティ / グループ",
        "Devices": "デバイス",
        "Last update": "最後の更新",
        "Offline": "オフライン",
        "Okay": "わかった",
        "In alarm": "アラームで",
        "Show with alarm only": "アラームのみで表示します",
        "Edit": "編集",
        "Delete": "消去",
        "Remove": "取り除く",
        "remove": "取り除く",
        "cancel": "キャンセル",
        "Create": "作成する",
        "Save": "保存",
        "Enable": "有効にする",
        "Disable": "無効にします",
        "enable": "有効にする",
        "disable": "無効にします",
        "Apply": "適用する",
        "all selected items": "選択したすべてのアイテム",
        "Please fill in all required fields before moving forward": "前進する前に、必要なすべてのフィールドに記入してください",
        "Are you sure that you want to {action}": "{{action}}したいのですが",
        "Alarm {action} successfully": "アラーム{{action}}正常に",
        "An error occurred while {action} alarm": "{{action}}アラーム中にエラーが発生しました",
        "Selected alarms are already {status}": "選択したアラームはすでに{{status}}です",
        "Alarm deleted successfully": "アラームは正常に削除されました",
        "An error occurred while deleting the alarm": "アラームの削除中にエラーが発生しました",
        "enabled": "有効になっています",
        "disabled": "無効",
        "enabled_other": "有効になっています",
        "disabled_other": "無効",
        "enabling": "有効化",
        "disabling": "無効化",
        "Select the type of asset you would like to create an alarm for": "アラームを作成したい資産の種類を選択します",
        "Select assets": "アセットを選択します",
        "Select Trigger Criteria": "[トリガー基準]を選択します",
        "Configure Notifications": "通知を構成します",
        "Add Name and Description": "名前と説明を追加します",
        "Conditions": "条件",
        "Trigger": "トリガータイプ",
        "Statistic": "統計",
        "Period": "期間",
        "{metric} graph": "{{metric}}グラフ",
        "Metric": "メトリック",
        "currentTrms": "TRMS",
        "currentAc": "AC",
        "currentDc": "DC",
        "activePowerTotal": "アクティブパワー",
        "activeEnergyTotal": "アクティブエネルギー",
        "Static": "静的",
        "threshold": "しきい値",
        "Use a value as a threshold": "しきい値として値を使用します",
        "Whenever {metric} is": "{{metric}}がいつでも",
        "Define alarm condition": "アラーム条件を定義します",
        "delay": "遅れ",
        "Define delay": "遅延を定義します",
        "CRITICAL": "致命的",
        "WARNING": "警告",
        "than": "よりも",
        "Define threshold": "しきい値を定義します",
        "Must be a number": "数字でなければなりません",
        "Notification title": "このアラームがトリガーされたときに通知する連絡先を選択します",
        "Select Contact": "連絡先を選択します",
        "Description": "説明",
        "Search": "検索",
        "Next": "次",
        "Back": "戻る",
        "{name} was created successfully": "{{name}}は正常に作成されました",
        "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました",
        "{name} was updated successfully": "{{name}}は正常に更新されました",
        "An error occurred while updating {name}": "{{name}}の更新中にエラーが発生しました"
      },
      "logs": {
        "Name": "名前",
        "Date": "日付",
        "Start Date - End Date": "開始日 - 終了日",
        "Status": "状態",
        "Condition": "状態",
        "Enabled": "有効になっています",
        "Properties": "プロパティ",
        "Groups": "グループ",
        "Devices": "デバイス",
        "Offline": "オフライン",
        "Okay": "わかった",
        "In alarm": "アラームで",
        "Start date": "開始日",
        "End date": "終了日",
        "Apply": "適用する",
        "Show with alarm only": "アラームのみで表示します",
        "Edit": "編集",
        "Delete": "消去",
        "cancel": "キャンセル",
        "Create": "作成する",
        "Enable": "有効にする",
        "Disable": "無効にします",
        "Trigger Time": "トリガー時間",
        "Acknowledged By": "認められた",
        "Category": "カテゴリ",
        "Do you confirm to set as acknowledged this alarm?": "このアラームが認められているように設定することを確認しますか？",
        "Set as acknowledged": "確認されたとおりに設定します",
        "Alarm acknowledged successfully": "アラームは正常に認められました",
        "An error occurred while acknowledging alarm": "アラームの確認中にエラーが発生しました",
        "Export": "輸出",
        "File exported successfully": "ファイルは正常にエクスポートされました",
        "An error occurred while exporting file": "ファイルのエクスポート中にエラーが発生しました",
        "Please enter a date range": "日付範囲を入力してください"
      }
    }
  },
  "wizard_first_access": {
    "The setup wizard is currently in use. Please wait a moment and try again.": "セットアップウィザードは現在使用されています。ちょっと待って、もう一度やり直してください。",
    "privacy notice": "ABB S.P.A.は、特にアクセスを許可して連絡するために個人データを処理します。 <a href = 'https：//new.abb.com/privacy-notice/ external-stakeholders' target = '_ blank' class = 'underline text-abb-primary hover：text-abb-primary/80'>プライバシー通知</a>",
    "Free trial period": "無料試用期間",
    "Accept terms & conditions": "利用規約を受け入れます",
    "As early user of the cloud application you will benefit from 12 months of unlimited device configuration... After 12 months you will have the freedom to decide using the application and purchase a license based on the N. of SCU200 connected or not using the cloud service anymore": "クラウドアプリケーションの初期のユーザーとして、12か月の無制限のデバイス構成の恩恵を受けるでしょう... 12か月後には、アプリケーションを使用して、SCU200の接続またはクラウドサービスを使用していないN.に基づくライセンスを自由に購入できます。",
    "earlyUserBenefitsMessagePart1": "Insite Energy Proは、6か月間の無制限のデバイス構成で初期のユーザーに無料で利益を得ます！",
    "earlyUserBenefitsMessagePart2": "6か月後：",
    "earlyUserBenefitsMessageItem1": "サービスを継続するには、特定の要件とニーズに応じて有効なライセンスを購入する必要があります。",
    "earlyUserBenefitsMessageItem2": "ユーザーは、クラウドサービスを継続するかどうかを自由に決定できます。",
    "earlyUserBenefitsMessagePart3": "ご質問や追加情報については、お客様の地元のABB担当者にお気軽にお問い合わせください。",
    "Next Step": "次のステップ",
    "Next": "次",
    "Step": "ステップ",
    "Add New Property": "新しいプロパティを追加します",
    "Gateway Connection": "次のステップ",
    "Devices Configuration": "デバイスの構成",
    "Final Summary": "最終要約",
    "Token Generation": "トークン生成",
    "Insert the following token in the SCU200 webserver for starting the linking process": "リンクプロセスを開始するために、SCU200 Webサーバーに次のトークンを挿入します",
    "SCU200 Link": "SCU200リンク",
    "{name} Linked Successfully": "{{name}}リンクされました",
    "Fw version": "FWバージョン",
    "Do you want to update to the latest firmware": "最新のファームウェアに更新しますか？",
    "Yes": "はい",
    "No": "いいえ",
    "Latest firmware version updated": "最新のファームウェアバージョンが更新されました",
    "Property {name}": "プロパティ{{name}}",
    "{name} connected": "{{name}}接続",
    "Devices Configured": "設定されたデバイス",
    "back": "戻る",
    "Configure another gateway for this property": "別のSCU200を構成します",
    "Configure another property": "別のプロパティを構成します",
    "All settled - Go to dashboard": "最終化します",
    "Scan again": "もう一度スキャンします",
    "Continue": "続く",
    "You will have the chance to configure additional gateways or new properties also later on directly from the Dashboard": "追加のゲートウェイまたは新しいプロパティをダッシュボードから直接構成する機会があります",
    "Image": "画像",
    "Device": "デバイス",
    "Status": "状態",
    "Category": "カテゴリ",
    "Property": "財産",
    "Update firmware": "ファームウェアを更新します",
    "Modbus ID": "Modbus ID",
    "Configure device": "デバイスを構成します",
    "cancel": "キャンセル",
    "Save": "保存",
    "Please fill in all required fields before moving forward": "前進する前に、必要なすべてのフィールドに記入してください",
    "{count} devices connected_one": "{{count}}デバイス接続",
    "{count} devices connected_other": "{{count}}デバイスが接続されています",
    "No response from the web server. Please check your internet connection or try again in a few minutes": "Webサーバーからの応答はありません。インターネット接続を確認するか、数分後に再試行してください",
    "Retry": "リトライ",
    "Waiting for webserver response": "Webサーバーの応答を待っています",
    "Retry attempt {retryCount}": "Retry Tirme {{retryCount}}",
    "Device configured successfully": "デバイスが正常に構成されています",
    "An error occurred while configuring device": "デバイスの構成中にエラーが発生しました",
    "{name} was created successfully": "{{name}}は正常に作成されました",
    "An error occurred while creating {name}": "{{name}}の作成中にエラーが発生しました"
  },
  "error": {
    "connection_error": "接続の問題のために操作を実行できません。ネットワークアクセスを確認してください"
  },
  "common": {
    "GREATER": "より大きい",
    "LOWER": "より小さい",
    "GREATEREQUAL": "以上",
    "LOWEREQUAL": "以下",
    "TRMS_A": "TRMS [A]",
    "AC_A": "そして[a]",
    "DC_A": "dc [a]",
    "ACTIVE_POWER_TOTAL_W": "アクティブパワー合計[W]",
    "ACTIVE_ENERGY_TOTAL_WH": "アクティブエネルギー合計[kWh]",
    "CURRENT_SENSOR": "現在のセンサー",
    "ENERGY_METER": "エネルギーメーター",
    "I_O_MODULE": "I/Oモジュール",
    "INS_S_H": "ins-s/h",
    "MODBUS": "modbus",
    "SCU200": "SCU200",
    "METER_W_MBUS": "メーターwmbus",
    "METER_LINKY": "メーターリンク",
    "METER_P1": "メーターP1",
    "THIRD_PARTY_RTU": "サードパーティRTU",
    "THIRD_PARTY_TCP": "サードパーティのTCP",
    "ACTIVE_POWER_IMPORT_W": "アクティブパワーインポート[W]",
    "REACTIVE_POWER_IMPORT_VAR": "リアクティブな電力インポート[var]",
    "ACTIVE_POWER_EXPORT_W": "アクティブパワーエクスポート[W]",
    "REACTIVE_POWER_EXPORT_VAR": "リアクティブな電力輸出[var]",
    "REACTIVE_POWER_TOTAL_VAR": "反応電力合計[var]",
    "CURRENT_L1_A": "現在のl1 [a]",
    "CURRENT_L2_A": "現在のL2 [a]",
    "CURRENT_L3_A": "現在のL3 [a]",
    "VOLTAGE_L1_V": "電圧L1 [V]",
    "VOLTAGE_L2_V": "電圧L2 [V]",
    "VOLTAGE_L3_V": "電圧L3 [V]",
    "FREQUENCY_HZ": "周波数[Hz]",
    "APPARENT_POWER_IMPORT_TOTAL_VA": "見かけの電力インポート合計[VA]",
    "APPARENT_POWER_IMPORT_L1_VA": "見かけの電力インポートL1 [VA]",
    "APPARENT_POWER_IMPORT_L2_VA": "見かけの電力インポートL2 [VA]",
    "APPARENT_POWER_IMPORT_L3_VA": "見かけの電力インポートL3 [VA]",
    "ACTIVE_POWER_IMPORT_L1_W": "アクティブパワーインポートL1 [W]",
    "ACTIVE_POWER_IMPORT_L2_W": "アクティブパワーインポートL2 [W]",
    "ACTIVE_POWER_IMPORT_L3_W": "アクティブパワーインポートL3 [W]",
    "ACTIVE_POWER_EXPORT_L1_W": "アクティブパワーエクスポートL1 [W]",
    "ACTIVE_POWER_EXPORT_L2_W": "アクティブパワーエクスポートL2 [W]",
    "ACTIVE_POWER_EXPORT_L3_W": "アクティブパワーエクスポートL3 [W]",
    "REACTIVE_POWER_IMPORT_L1_VAR": "リアクティブパワーインポートL1 [var]",
    "REACTIVE_POWER_IMPORT_L2_VAR": "リアクティブパワーインポートL2 [var]",
    "REACTIVE_POWER_IMPORT_L3_VAR": "リアクティブパワーインポートL3 [var]",
    "REACTIVE_POWER_EXPORT_L1_VAR": "リアクティブパワーエクスポートL1 [var]",
    "REACTIVE_POWER_EXPORT_L2_VAR": "リアクティブパワーエクスポートL2 [var]",
    "REACTIVE_POWER_EXPORT_L3_VAR": "リアクティブパワーエクスポートL3 [var]",
    "THREE_PHASE_SYSTEM_VOLTAGE_V": "三相システム電圧[V]",
    "THREE_PHASE_SYSTEM_CURRENT_A": "三相システム電流[a]",
    "PORT1_STATUS_CHANGE_COUNTER": "ポート1ステータス変更カウンター",
    "PORT2_STATUS_CHANGE_COUNTER": "ポート2ステータス変更カウンター",
    "PORT3_STATUS_CHANGE_COUNTER": "ポート3ステータス変更カウンター",
    "PORT4_STATUS_CHANGE_COUNTER": "ポート4ステータス変更カウンター",
    "PORT1_PULSE_COUNTER_ACCUMULATED": "ポート1パルスカウンターが蓄積しました",
    "PORT2_PULSE_COUNTER_ACCUMULATED": "ポート2パルスカウンターが蓄積しました",
    "PORT3_PULSE_COUNTER_ACCUMULATED": "ポート3パルスカウンターが蓄積しました",
    "PORT4_PULSE_COUNTER_ACCUMULATED": "ポート4パルスカウンターが蓄積しました",
    "SWITCH_1": "スイッチ1",
    "SWITCH_2": "スイッチ2",
    "TEMPERATURE_1_C": "温度1 [°C]",
    "TEMPERATURE_2_C": "温度2 [°C]",
    "TEMPERATURE_3_C": "温度3 [°C]",
    "TEMPERATURE_4_C": "温度4 [°C]",
    "INPUT_VOLTAGE_V": "入力電圧[V]",
    "VOLTAGE_L1_L2_V": "電圧L1-L2 [V]",
    "VOLTAGE_L3_L2_V": "電圧L3-L2 [V]",
    "VOLTAGE_L1_L3_V": "電圧L1-L3 [V]",
    "CURRENT_N_A": "現在のn [a]",
    "ACTIVE_POWER_L1_W": "アクティブパワーL1 [W]",
    "ACTIVE_POWER_L2_W": "アクティブパワーL2 [W]",
    "ACTIVE_POWER_L3_W": "アクティブパワーL3 [W]",
    "REACTIVE_POWER_L1_VAR": "リアクティブパワーL1 [var]",
    "REACTIVE_POWER_L2_VAR": "リアクティブパワーL2 [var]",
    "REACTIVE_POWER_L3_VAR": "反応電力l3 [var]",
    "APPARENT_POWER_L1_VA": "見かけのパワーL1 [VA]",
    "APPARENT_POWER_L2_VA": "見かけのパワーL2 [VA]",
    "APPARENT_POWER_L3_VA": "見かけのパワーL3 [VA]",
    "CURRENT_QUADRANT_L1": "現在の象限L1",
    "CURRENT_QUADRANT_L2": "現在の象限L2",
    "CURRENT_QUADRANT_L3": "現在の象限L3",
    "POWER_FACTOR_L1": "力率L1",
    "POWER_FACTOR_L2": "力率L2",
    "POWER_FACTOR_L3": "力率L3",
    "POWER_FACTOR_TOTAL": "力率合計",
    "APPARENT_POWER_TOTAL_VA": "見かけの電力合計[VA]",
    "COS_PHI_L1": "cos phi l1",
    "COS_PHI_L2": "cos phi l2",
    "COS_PHI_L3": "cos phi l3",
    "COS_PHI_3_PHASE": "Cos Phi 3フェーズ",
    "CTL1_L2_L3_RATIO_DENOMINATOR": "CTL1 L2-L3比分母",
    "CURRENT_QUADRANT_TOTAL": "現在の象限合計",
    "ACTIVE_ENERGY_NET_TOTAL": "アクティブエネルギーネット合計[kWh]",
    "REACTIVE_ENERGY_EXPORT_TOTAL": "反応性エネルギー輸出合計",
    "ACTIVE_ENERGY_CO2": "アクティブエネルギーCO2",
    "REACTIVE_ENERGY_IMPORT_TOTAL": "反応性エネルギーの輸入合計",
    "ACTIVE_ENERGY_CURRENCY": "アクティブなエネルギー通貨",
    "ACTIVE_ENERGY_IMPORT_TOTAL": "アクティブなエネルギー輸入合計",
    "APPARENT_ENERGY_NET_TOTAL": "見かけのエネルギー純合計",
    "APPARENT_ENERGY_NET_L2": "見かけのエネルギーネットL2",
    "ACTIVE_ENERGY_EXPORT_TOTAL": "アクティブなエネルギー輸出合計",
    "APPARENT_ENERGY_NET_L1": "見かけのエネルギーネットL1",
    "REACTIVE_ENERGY_NET_TOTAL": "反応性エネルギー純合計",
    "APPARENT_ENERGY_NET_L3": "見かけのエネルギーネットL3",
    "ACTIVE_ENERGY_EXPORT_TOTAL_KWH": "アクティブエネルギー輸出合計[kwh]",
    "ACTIVE_ENERGY_IMPORT_TOTAL_KWH": "アクティブなエネルギーインポート合計[kwh]",
    "ACTIVE_ENERGY_NET_TOTAL_KWH": "アクティブエネルギーネット合計[kWh]",
    "APPARENT_ENERGY_NET_L1_KWH": "見かけのエネルギーネットL1 [kWh]",
    "APPARENT_ENERGY_NET_L2_KWH": "見かけのエネルギーネットL2 [kWh]",
    "APPARENT_ENERGY_NET_L3_KWH": "明らかなエネルギーネットL3 [kWh]",
    "APPARENT_ENERGY_NET_TOTAL_KWH": "見かけのエネルギーネット合計[kWh]",
    "REACTIVE_ENERGY_EXPORT_TOTAL_KWH": "反応性エネルギー輸出合計[kwh]",
    "REACTIVE_ENERGY_IMPORT_TOTAL_KWH": "反応性エネルギー輸入合計[kwh]",
    "REACTIVE_ENERGY_NET_TOTAL_KWH": "リアクティブエネルギーネット合計[kWh]",
    "ACTIVE_ENERGY": "アクティブエネルギー",
    "APPARENT_ENERGY_NET": "見かけのエネルギーネット",
    "ENERGY_KWH": "アクティブエネルギー[kWh]",
    "ACTIVE_ENERGY_IMPORT": "アクティブなエネルギー輸入",
    "PORT1_PULSE_COUNTER_ACCUMULATED_VALUE": "ポート1パルスカウンターの蓄積値",
    "PORT2_PULSE_COUNTER_ACCUMULATED_VALUE": "ポート2パルスカウンター累積値",
    "PORT3_PULSE_COUNTER_ACCUMULATED_VALUE": "ポート3パルスカウンター累積値",
    "PORT4_PULSE_COUNTER_ACCUMULATED_VALUE": "ポート4パルスカウンター累積値",
    "PORT1_STATE": "ポート1状態",
    "PORT2_STATE": "ポート2状態",
    "PORT3_STATE": "ポート3状態",
    "PORT4_STATE": "ポート4状態",
    "CURRENT_HARMONICS_THD_L1": "現在のハーモニクスTHD L1",
    "CURRENT_HARMONICS_THD_L2": "現在のハーモニクスTHD L2",
    "CURRENT_HARMONICS_THD_L3": "現在のハーモニクスTHD L3",
    "CURRENT_HARMONICS_THD_N": "現在のハーモニクスthd n",
    "PHASE_ANGLE_CURRENT_L1": "位相角電流L1",
    "PHASE_ANGLE_CURRENT_L2": "位相角電流L2",
    "PHASE_ANGLE_CURRENT_L3": "位相角電流L3",
    "POWER_ANGLE_POWER_L1": "パワーアングルパワーL1",
    "POWER_ANGLE_POWER_L2": "パワーアングルパワーL2",
    "POWER_ANGLE_POWER_L3": "パワーアングルパワーL3",
    "POWER_ANGLE_POWER_TOTAL": "パワーアングルパワー合計",
    "PHASE_ANGLE_VOLTAGE_L1": "位相角電圧L1",
    "PHASE_ANGLE_VOLTAGE_L2": "位相角度電圧L2",
    "PHASE_ANGLE_VOLTAGE_L3": "位相角度電圧L3",
    "VOLTAGE_HARMONICS_THD_L1": "電圧ハーモニクスTHD L1",
    "VOLTAGE_HARMONICS_THD_L2": "電圧ハーモニクスTHD L2",
    "VOLTAGE_HARMONICS_THD_L3": "電圧ハーモニクスTHD L3",
    "REACTIVE_POWER_IMPORT_TOTAL_VAR": "リアクティブな電力インポート合計[var]",
    "REACTIVE_POWER_EXPORT_TOTAL_VAR": "リアクティブ電力輸出合計[var]",
    "ACTIVE_POWER_IMPORT_TOTAL_W": "アクティブパワーインポート合計[W]",
    "ACTIVE_ENERGY_IMPORT_L1": "アクティブエネルギーインポートL1",
    "ACTIVE_ENERGY_IMPORT_L2": "アクティブエネルギーインポートL2",
    "ACTIVE_ENERGY_IMPORT_L3": "アクティブエネルギーインポートL3",
    "ACTIVE_ENERGY_EXPORT_L1": "アクティブエネルギー輸出L1",
    "ACTIVE_ENERGY_EXPORT_L2": "アクティブエネルギー輸出L2",
    "ACTIVE_ENERGY_EXPORT_L3": "アクティブエネルギー輸出L3",
    "ACTIVE_ENERGY_NET_L1": "アクティブエネルギーネットL1",
    "ACTIVE_ENERGY_NET_L2": "アクティブエネルギーネットL2",
    "ACTIVE_ENERGY_NET_L3": "アクティブエネルギーネットL3",
    "REACTIVE_ENERGY_EXPORT_L1": "反応性エネルギー輸出L1",
    "REACTIVE_ENERGY_EXPORT_L2": "反応性エネルギー輸出L2",
    "REACTIVE_ENERGY_EXPORT_L3": "反応性エネルギー輸出L3",
    "REACTIVE_ENERGY_IMPORT_L1": "反応性エネルギーインポートL1",
    "REACTIVE_ENERGY_IMPORT_L2": "反応性エネルギーインポートL2",
    "REACTIVE_ENERGY_IMPORT_L3": "反応性エネルギーインポートL3",
    "REACTIVE_ENERGY_NET_L1": "反応性エネルギーネットL1",
    "REACTIVE_ENERGY_NET_L2": "反応性エネルギーネットL2",
    "REACTIVE_ENERGY_NET_L3": "反応性エネルギーネットL3",
    "ACTIVE_POWER_EXPORT_TOTAL_W": "アクティブパワーエクスポート合計[W]",
    "ACTIVE_POWER_TOTAL_KW": "アクティブパワー合計[kw]",
    "TOTAL_COST_EUR": "総コスト[â¬]",
    "ACTIVE_POWER_TOTAL": "アクティブパワー合計",
    "ACTIVE_IMPORT_TOTAL": "アクティブなインポート合計",
    "ACTIVE_EXPORT_TOTAL": "アクティブなエクスポート合計",
    "REACTIVE_IMPORT_TOTAL": "リアクティブインポート合計",
    "REACTIVE_EXPORT_TOTAL": "反応性エクスポート合計",
    "PORT1_STATUS_CHANGE": "ポート1ステータスの変更",
    "PORT2_STATUS_CHANGE": "ポート2ステータスの変更",
    "PORT3_STATUS_CHANGE": "ポート3ステータスの変更",
    "PORT4_STATUS_CHANGE": "ポート4ステータスの変更",
    "SYSTEM": "システム",
    "CROSS_UP": "クロスアップ",
    "CROSS_DOWN": "クロスダウン",
    "STATUS_CHANGE": "ステータスの変更",
    "COMMUNICATION_FAILURE": "コミュニケーションの失敗",
    "COMMUNICATION_RESTORE": "コミュニケーションの復元",
    "STATUS_CHANGE_TO_CLOSED": "ステータスが閉じて変更されます",
    "STATUS_CHANGE_TO_OPEN": "ステータスが開くように変更されます",
    "AUTOMATION_SUCCESS": "自動化の成功",
    "AUTOMATION_FAILURE": "自動障害",
    "VALUE_MATCH": "値マッチ",
    "STATUS_CHANGE_TO_ON": "ステータスがオンに変更されます",
    "STATUS_CHANGE_TO_OFF": "ステータスがオフに変更されます",
    "VALUE_CHANGE": "価値の変化",
    "INSITE_BUS": "インサイトバス",
    "METERING_MODULES": "計量モジュール",
    "WIRELESS_M_BUS": "ワイヤレスMバス",
    "USB_DEVICE": "USBデバイス",
    "MODBUS_RTU_RS485_DEVICES": "Modbus RTU RS485デバイス",
    "MODBUS_TCP_DEVICES": "modbus TCPデバイス",
    "GOOD": "良い",
    "TO_BE_IMPROVED": "改善される",
    "CONSUMPTION": "消費",
    "TOTAL_COST": "総コスト",
    "ACTIVE_ENERGY_EXPORT": "アクティブなエネルギー輸出",
    "ACTIVE_ENERGY_NET": "アクティブエネルギーネット",
    "APPARENT_ENERGY_EXPORT": "見かけのエネルギー輸出",
    "APPARENT_ENERGY_IMPORT": "見かけのエネルギー輸入",
    "REACTIVE_ENERGY_NET": "反応性エネルギーネット",
    "REACTIVE_ENERGY_IMPORT": "反応性エネルギー輸入",
    "REACTIVE_ENERGY_EXPORT": "反応性エネルギー輸出",
    "GAS_CONSUMPTION": "ガス消費",
    "WATER_CONSUMPTION": "水の消費",
    "CHARGING_STATE": "充電状態",
    "FIRMWARE_VERSION": "ファームウェアバージョン",
    "INPUT_1_COUNTER": "入力1カウンター",
    "INPUT_2_COUNTER": "入力2カウンター",
    "INPUT_3_COUNTER": "入力3カウンター",
    "INPUT_4_COUNTER": "入力4カウンター",
    "INPUT_3_CURRENT_STATE": "入力3電流状態",
    "INPUT_3_STORED": "入力3保存",
    "INPUT_4_CURRENT_STATE": "入力4電流状態",
    "INPUT_4_STORED": "入力4保存",
    "MESSAGE1": "メッセージ1",
    "MESSAGE2": "メッセージ2",
    "OUTPUT_1": "出力1",
    "OUTPUT_2": "出力2",
    "OUTPUT_3": "出力3",
    "OUTPUT_4": "出力4",
    "REFERENCE_APPARENT_POWER": "基準皮相電力",
    "REFERENCE_BREAKING_CAPACITY": "基準遮断容量",
    "RELAY1": "リレー1",
    "RELAY2": "リレー2",
    "RELAY3": "リレー3",
    "RELAY4": "リレー4",
    "RELAY5": "リレー5",
    "RELAY6": "リレー6",
    "RELAY7": "リレー7",
    "RELAY8": "リレー8",
    "SERIAL_NUMBER": "シリアルナンバー",
    "SOCKET_LOCK_STATE": "ソケットロック状態",
    "STATUS_REGISTER": "ステータスレジスタ",
    "VOLTAGE_HARMONICS_THD_L1_L2": "電圧ハーモニクスTHD L1-L2",
    "VOLTAGE_HARMONICS_THD_L2_L3": "電圧ハーモニクスTHD L2-L3",
    "VOLTAGE_HARMONICS_THD_L3_L2": "電圧ハーモニクスTHD L3-L2",
    "VOLTAGE_HARMONICS_THD_L1_L3": "電圧ハーモニクスTHD L1-L3",
    "PHASE_ANGLE_POWER_L1": "位相角度電力L1",
    "PHASE_ANGLE_POWER_L2": "位相角度電力L2",
    "PHASE_ANGLE_POWER_L3": "位相角度電力L3",
    "PHASE_ANGLE_POWER_TOTAL": "位相角度電力合計",
    "ACTIVE_POWER_L1": "アクティブ電力L1",
    "ACTIVE_POWER_L2": "アクティブ電力L2",
    "ACTIVE_POWER_L3": "アクティブ電力L3",
    "APPARENT_ENERGY_EXPORT_L1": "見かけのエネルギー輸出L1",
    "APPARENT_ENERGY_EXPORT_L2": "見かけのエネルギー輸出L2",
    "APPARENT_ENERGY_EXPORT_L3": "見かけのエネルギー輸出L3",
    "APPARENT_ENERGY_EXPORT_TOTAL": "見かけのエネルギー輸出合計",
    "APPARENT_ENERGY_IMPORT_L1": "見かけのエネルギー輸入L1",
    "APPARENT_ENERGY_IMPORT_L2": "見かけのエネルギー輸入L2",
    "APPARENT_ENERGY_IMPORT_L3": "見かけのエネルギー輸入L3",
    "APPARENT_ENERGY_IMPORT_TOTAL": "見かけのエネルギー輸入合計",
    "APPARENT_POWER_TOTAL": "見かけの電力合計",
    "APPARENT_POWER_L1":" 見かけのパワーL1",
    "APPARENT_POWER_L2":" 見かけのパワーL2",
    "APPARENT_POWER_L3":" 見かけのパワーL3",
    "REACTIVE_POWER_L1": "無効電力L1",
    "REACTIVE_POWER_L2": "無効電力L2",
    "REACTIVE_POWER_L3": "無効電力L3",
    "REACTIVE_POWER_TOTAL": "無効電力合計",
    "ACTIVE_ENERGY_EXPORT_L1_KWH": "アクティブエネルギー輸出L1 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L2_KWH": "アクティブエネルギー輸出L2 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L3_KWH": "アクティブエネルギー輸出L3 [kWh]"
  }
}
